var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.996,
    height: 22.148,
    viewBox: "0 0 23.996 22.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_279",
    d: "M17406.15,7043.15h-20.3a1.844,1.844,0,0,1-1.844-1.839v-7.863a33.46,33.46,0,0,0,11.959,2.323h.066a33.455,33.455,0,0,0,11.971-2.322v7.863A1.846,1.846,0,0,1,17406.15,7043.15Zm-10.1-9.228h-.1a30.48,30.48,0,0,1-11.947-2.508v-4.876a1.849,1.849,0,0,1,1.844-1.848h4.613v-.922a2.772,2.772,0,0,1,2.771-2.766h5.535a2.772,2.772,0,0,1,2.771,2.766v.922h4.613a1.851,1.851,0,0,1,1.848,1.848v4.876A30.474,30.474,0,0,1,17396.049,7033.922Zm-1.434-3.692a.924.924,0,0,0,0,1.848h2.766a.924.924,0,1,0,0-1.848Zm-1.385-7.384a.924.924,0,0,0-.926.922v.922h7.387v-.922a.924.924,0,0,0-.926-.922Z",
    transform: "translate(-17384.002 -7021.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.755bbf015595fa264cc5919bd694be0f.svg";
export { ForwardRef as ReactComponent };